import { render, staticRenderFns } from "./ServiceSettings.vue?vue&type=template&id=608d0887&scoped=true"
import script from "./ServiceSettings.vue?vue&type=script&lang=js"
export * from "./ServiceSettings.vue?vue&type=script&lang=js"
import style0 from "./ServiceSettings.vue?vue&type=style&index=0&id=608d0887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d0887",
  null
  
)

export default component.exports